<template>
  <div>
    <v-snackbar
      v-model="showOrderConfSnackbar"
      :timeout="3000"
      vertical
      :style="`margin-bottom:${_includes(['xs', 'sm'], $mq) ? 130 : 80}px`"
      color="blue darken-1"
      ><h1>Thank you! 🎉</h1>
      <h3 class="pb-3">
        Your order has been received.
      </h3>
    </v-snackbar>
    <v-snackbar
      v-model="showAccountCreatedSnackbar"
      vertical
      color="blue-grey lighten-2"
      ><h1>Woo!</h1>
      <h3 class="pb-3">
        Your account has been created.
      </h3>
    </v-snackbar>
    <v-snackbar
      v-model="showAccountUpdatedSnackbar"
      vertical
      :style="`margin-bottom:${_includes(['xs', 'sm'], $mq) ? 130 : 80}px`"
      color="blue darken-1"
      ><h1>Success! 🎉</h1>
      <h3 class="pb-3">
        Your account has been updated.
      </h3>
    </v-snackbar>
    <v-snackbar v-model="showLoggedOutSnackbar" color="blue-grey lighten-2">
      <h2>
        You've been successfully logged out.
      </h2>
    </v-snackbar>
    <v-snackbar v-model="showPasswordUpdatedSnackbar" color="blue darken-1">
      <div class="text-center">
        <h2>
          Your password has been updated!
        </h2>
      </div>
    </v-snackbar>
    <v-snackbar v-model="showRecordDeletedSnackbar" color="black lighten-2">
      <div class="text-center">
        <h2>Successfully deleted.</h2>
      </div>
    </v-snackbar>
    <v-snackbar v-model="showRecordClonedSnackbar" color="blue darken-1">
      <div class="text-center">
        <h2>Duplicated 1 Record.</h2>
      </div>
    </v-snackbar>
    <v-snackbar
      v-model="showMenuRearrangedSnackbar"
      color="blue darken-1"
      timeout="1200"
    >
      <div class="text-center proxima-bold--font">
        Menu Order Updated
      </div>
    </v-snackbar>
    <v-snackbar v-model="showEmailVerifiedSnackbar" color="blue darken-1">
      <div class="text-center">
        <h2>Nice! Your email has been verified.</h2>
      </div>
    </v-snackbar>
    <v-snackbar
      v-model="showExportSuccessSnackbar"
      vertical
      color="blue darken-1"
      class="proxima--font"
      ><h2 class="pb-3">Huzzah! 🎉</h2>
      <h3 class="pb-3">
        Your Export was successful. The download should start any second.
      </h3>
    </v-snackbar>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters, mapActions } from 'vuex'
import _includes from 'lodash/includes'
export default {
  name: 'Snackbars',
  components: {},
  data() {
    return {}
  },
  methods: {
    ...mapActions('snackbars', [
      'setAccountCreatedSnackbar',
      'setAccountUpdatedSnackbar',
      'setLoggedOutSnackbar',
    ]),
    ...mapActions('cart', ['setOrderConfSnackbar']),
    _includes,
  },
  computed: {
    ...mapGetters('snackbars', [
      'getShowAccountCreatedSnackbar',
      'getShowAccountUpdatedSnackbar',
      'getShowLoggedOutSnackbar',
    ]),
    ...mapFields('snackbars', [
      'showPasswordUpdatedSnackbar',
      'showRecordDeletedSnackbar',
      'showEmailVerifiedSnackbar',
      'showRecordClonedSnackbar',
      'showMenuRearrangedSnackbar',
      'showExportSuccessSnackbar',
    ]),
    ...mapGetters('cart', ['getShowOrderConfSnackbar']),
    showOrderConfSnackbar: {
      get() {
        return this.getShowOrderConfSnackbar
      },
      set(val) {
        this.setOrderConfSnackbar(val)
      },
    },
    showAccountCreatedSnackbar: {
      get() {
        return this.getShowAccountCreatedSnackbar
      },
      set(val) {
        this.setAccountCreatedSnackbar(val)
      },
    },
    showAccountUpdatedSnackbar: {
      get() {
        return this.getShowAccountUpdatedSnackbar
      },
      set(val) {
        this.setAccountUpdatedSnackbar(val)
      },
    },
    showLoggedOutSnackbar: {
      get() {
        return this.getShowLoggedOutSnackbar
      },
      set(val) {
        this.setLoggedOutSnackbar(val)
      },
    },
  },
}
</script>
